import { createHighContrastTheme } from '../../utils/createHighContrastTheme';
import type { Theme } from '../../types';

export const teamsHighContrastTheme: Theme = createHighContrastTheme();
